import { Component, EventEmitter, Output } from '@angular/core';
import { Common } from '../../shared/common';

@Component({
  selector: 'add-user-failed-popup',
  templateUrl: './add-user-failed-popup.component.html',
  styleUrls: ['./add-user-failed-popup.component.less', '../../shared/common.less']
})
export class AddUserFailedPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  isFormValid: boolean = false;
  
  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  ngOnInit() {}
}
